module.exports = __webpack_public_path__ + "images/emoji/tractor.fb1ff3831ff09f00736b.png";